import { SERVICE_OGP_IMAGE, SITE_URL } from '../../constants'
import { buildServiceSchema } from '../../builders/service'
import { PageMeta } from '../../types'

const description = "「生成AIを試したが、思うような出力が得られない」その課題、特徴量エンジニアリングで解決できます。顧客固有データでモデルをゼロから学習させ、汎用LLMより高精度・低リソースなAIをPoCから本番導入まで支援します。"

export const featureEngineeringPageMeta: PageMeta = {
  title: "生成AIの精度を上げるPoC支援｜特徴量エンジニアリング活用 | i3DESIGN",
  description,
  keyword: "特徴量エンジニアリング、生成AI、UI、トランスフォーマーベースモデル",
  image: SERVICE_OGP_IMAGE,
  url: `${SITE_URL}/services/feature-engineering/`,
}

export const featureEngineeringSchema = buildServiceSchema({
  slug: "feature-engineering",
  name: "特徴量エンジニアリングと生成AI",
  description: featureEngineeringPageMeta.description,
  serviceType: "特徴量エンジニアリングと生成AI",
  category: "モダンアプリケーション開発",
  offerCatalogName: "デジタルPoC",
  breadcrumbName: "特徴量エンジニアリングと生成AI",
  offers: [
    {
      name: "AIエージェント導入支援",
      description: "生成AIで十分なアウトプットが得られないと試行錯誤している企業に、当社の特徴量エンジアリングを活用したノウハウならびにPoCを実施します。最新のAIテクノロジーを顧客に提供することで、革新的なサービスや製品の実現を支援します。",
    }
  ],
})
